import { render, staticRenderFns } from "./IntelligentBookingResultXhq.vue?vue&type=template&id=1486f980&"
import script from "./IntelligentBookingResultXhq.vue?vue&type=script&lang=js&"
export * from "./IntelligentBookingResultXhq.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentBookingResultXhq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1486f980')) {
      api.createRecord('1486f980', component.options)
    } else {
      api.reload('1486f980', component.options)
    }
    module.hot.accept("./IntelligentBookingResultXhq.vue?vue&type=template&id=1486f980&", function () {
      api.rerender('1486f980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultXhq.vue"
export default component.exports